// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 774 ? "framework" : chunkId) + "-" + {"604":"b611dc502e19d7099583","774":"d703a40db0a1085f3f94","848":"d4765558b53a7b178738","879":"5091c535689f84af280b"}[chunkId] + ".js";
};